import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { ActivityEventService } from '@core/services/entities/activity-event.service';
import { ActivityEventResponseDto } from '@domain/activity-event/dtos/activity-event.response.dto';
import { ListActivityEventRequestDto } from '@domain/activity-event/dtos/list-activity-event.request.dto';
import { ActivityEventRepository } from '@domain/activity-event/repositories/activity-event.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ActivityEventRepositoryService implements ActivityEventRepository {
  constructor(private activityEventService: ActivityEventService) {}
  show(request: RefId): Observable<ApiResponse<ActivityEventResponseDto>> {
    return this.activityEventService.show(request);
  }
  list(
    request: ListActivityEventRequestDto,
  ): Observable<ApiResponse<PageableResponse<ActivityEventResponseDto>>> {
    return this.activityEventService.list(request);
  }
}
